import logo2 from "./Tributum-Logo-2.png";
import Hamburger from "./hamburger.svg";
import bluebgimage from "./bluebgimage.png";
import footerlogos3 from "./footerlogos3.png";

export const assets = {
  logo2,
  Hamburger,
  bluebgimage,
  footerlogos3,
};
